export default __webpack_public_path__ + "css/patientinvite.module.css";